import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/_services/login.service';
import { first } from 'rxjs/operators';

declare var jquery: any;
declare var $: any;

import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loading = false;
  submitted = false;
  responseData: any;
  errorData = false;
  public form: FormGroup = Object.create(null);
  date: number | undefined;
  constructor(private fb: FormBuilder, private router: Router,private loginService: LoginService) { }
  curryear:any;
  
  ngOnInit() {
    if(localStorage.getItem('currentUser')==null){
      this.router.navigate(['/']);
    }else{
      this.router.navigate(['/dashboards/dashboard1']);
    }
    this.form = this.fb.group({
      name: [null, Validators.required],
      password: [null,Validators.required]
    });
    this.date = new Date().getFullYear();
    console.log(this.date)
    this.curryear = new Date().getFullYear();
  }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

  onSubmit() {
   
    
    if(this.form.valid){
      this.loading = true;
      this.submitted = false;
    
    this.loginService.login(this.f.name.value, this.f.password.value)
        .pipe(first())
        .subscribe({
            next: (data) => {
              this.responseData=data;
              //console.log(data);return false;
              if(this.responseData.msg =='Success'){
                this.loading = false;
                localStorage.setItem('currentUser',this.f.name.value );
                this.router.navigate(['/dashboards/dashboard1']);
              }else{

                this.errorData = true;
              
              }
            },
            error:() => {
                this.loading = false;
            }
        });

      }  else{
        this.submitted=true;
      }

    }

}




